<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="50%">
        <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" />
        <div class="detailMsg">
            <BaseList :detailObj="detailObj" :baseMsg="baseMsg" :isMode="isMode" ref="BaseList" v-bind="$attrs" @modeChanges="modeChanges" @saveDecFn="confrimFn" />
            <Upload :Upload="Upload" :isMode="isMode" ref="upload" />
            <changeIcon :isMode="isMode" @modeChange="modeChange" />
        </div>
        <Tabs :tabs="tabsArray" :activeCom.sync="TabsActive" @handleTabs="handleTabs" />
        <keep-alive>
            <component :is="TabsActive" :detailNetObj="netObj" v-bind="$attrs" />
        </keep-alive>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Close') }}</el-button>
        </div>
    </modal>
</template>

<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue';
import Application from '@/pages/equipment/publicCom/Application.vue';
import NetParam from '@/pages/equipment/publicCom/NetParam.vue';
import changeIcon from '@/pages/equipment/publicCom/changeIcon.vue';
import Upload from '@/pages/equipment/publicCom/Upload.vue';
import BaseList from './detail/BaseList.vue';

import { relayUpdateRelay } from '@/api/modules/relay.js';
export default {
    props: ['title', 'isDetailShow', 'detailNetObj', 'detailObj'],
    components: {
        Tabs,
        BaseList,
        Application,
        NetParam,
        Upload,
        changeIcon
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isDetailShow;
            },
            set: function(val) {
                this.$emit('update:isDetailShow', val); //可以优化成model  或者minx
            }
        }
    },
    watch: {
        detailRuleObj(newVal) {
            this.appObj.forEach(item => {
                item.content = newVal[item.key];
            });
        },
        detailNetObj(newVal) {
            this.netObj.forEach(item => {
                item.content = newVal[item.key];
            });
        }
    },
    data() {
        return {
            isMode: false,
            detailTbs: [
                {
                    name: 'Detail',
                    label: 'public.detail_info'
                }
            ],
            Dactive: 'Detail',
            // 设备tabs
            tabsArray: [
                {
                    name: 'Application',
                    label: 'public.attribute'
                },
                {
                    name: 'NetParam',
                    label: 'public.net_param'
                }
            ],
            TabsActive: 'Application',
            // 图片
            Upload: {},
            baseMsg: [
                {
                    text: 'public.belong',
                    key: 'url'
                },
                {
                    text: $t('integration.trunk_number'),
                    key: 'relayCode'
                },
                {
                    text: $t('integration.relay_nickname'),
                    key: 'nickname'
                },
                {
                    text: 'device.config_status',
                    key: 'configStatus'
                },
                {
                    text: $t('integration.mount_'),
                    key: 'carrierName'
                },
                {
                    text: $t('integration.relay_type'),
                    key: 'type'
                },
                {
                    text: 'public.table_create_time',
                    key: 'createTime'
                },
                {
                    text: $t('integration.update_time'),
                    key: 'stopTime'
                },

                {
                    text: $t('public.table_desc'),
                    key: 'description'
                }
            ],
            appObj: [
                {
                    text: $t('integration.alarm_or_not'),
                    key: 'alarmOn',
                    content: '123'
                },
                {
                    text: $t('integration.duration_(seconds)'),
                    key: 'alarmInterval',
                    content: '123'
                },
                {
                    text: $t('integration.interval_time_(seconds)'),
                    key: 'alarmPeriod',
                    content: '123'
                }
            ],
            netObj: [
                {
                    text: 'ext Pan Id',
                    key: 'extPanId',
                    content: '123'
                },
                {
                    text: 'Join Attemp',
                    key: 'channelPage',
                    content: '123'
                },
                {
                    text: 'device.transmit_power',
                    key: 'transmitPower',
                    content: '123'
                },
                {
                    text: 'device.channel_mask',
                    key: 'channelMask',
                    content: '123'
                },
                {
                    text: 'device.in_net_interval',
                    key: 'inNetInterval',
                    content: '123'
                }
            ],
            description: '',
            isEdit: true
        };
    },
    mounted() {
        if (this.$attrs['sensorWay'] !== 'bind' && this.$attrs['sensorWay'] !== 'stop') {
            this.baseMsg.splice(4, 1);
        }
    },
    methods: {
        modeChange() {
            this.isMode = !this.isMode;
        },
        modeChanges(row) {
            this.isMode = !this.isMode;
            this.$parent.detailFn(row);
        },
        handleTabs(name) {
            this.TabsActive = name;
        },
        handleEdit() {
            this.isEdit = !this.isEdit;
        },
        confrimFn(row) {
            const { imageSuffix, imageUrl } = this.$refs['upload'].newUpload;
            const { id, isHeart, nickname, areaValue } = row;

            relayUpdateRelay({
                id,
                isHeart,
                nickname,
                description: areaValue,
                uploadFileBase64: imageUrl,
                uploadFileSuffix: imageSuffix
            }).then(async ({ state }) => {
                await this.$resultHandle(state);
                this.isEdit = !this.isEdit;
                this.isMode = !this.isMode;
                this.$parent.detailFn(this.detailObj);
                this.$parent.getListFn();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.detailMsg {
    display: flex;
}

// .detailPage {
//   h1 {
//     font-size: 16px;
//     font-weight: bold;
//     margin-top: 5px;
//     margin-bottom: 10px;
//     padding-bottom: 5px;
//     border-bottom: 1px solid #ccc;
//   }

//   ::v-deep .el-textarea__inner {
//     border-radius: 2px;
//     margin-left: 5px;
//   }

//   li {
//     line-height: 28px;
//     font-size: 14px;
//     color: #606266;
//   }

//   i {
//     cursor: pointer;
//     margin-left: 10px;
//   }
// }
</style>
